import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { reverseDate } from "../../utils/commonFunctions";
import { CircularAvatar, Loader, RadioContainer } from "../commons";
import CustomizedAvatar from "../commons/CircularAvatar/CustomizedAvatar";
import {
  BriefCase,
  IdBadge,
  InterviewStatusIcon,
  LoctionRedIcon,
  NoticeCalendarIcon,
} from "../../assets/images";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { RadioTypes } from "../../commonTypes/universalTypes";
import { RESPONSE_STATUS_RADIO_OPTIONS } from "../MySpace/CheckInModule/AllCheckInList";
type AppProps = {
  toggle: () => void;
  isOpen: boolean;
  data: any;
  handleSubmitFeedback?: () => void;
  loginData: LoginResponseType;
  fetching: boolean;
  feedback: string;
  setFeedback: React.Dispatch<React.SetStateAction<string>>;
  optionList?: RadioTypes[];
  setQuestionOneResponse?: React.Dispatch<React.SetStateAction<string>>;
  questionOneResponse?: string;
  setQuestionTwoResponse?: React.Dispatch<React.SetStateAction<string>>;
  questionTwoResponse?: string;
  setQuestionThreeResponse?: React.Dispatch<React.SetStateAction<string>>;
  questionThreeResponse?: string;
  type?: string;
  questionOneCommentResponse?: string;
  questionTwoCommentResponse?: string;
  questionThreeCommentResponse?: string;
  setQuestionOneCommentResponse?: React.Dispatch<React.SetStateAction<string>>;
  setQuestionTwoCommentResponse?: React.Dispatch<React.SetStateAction<string>>;
  setQuestionThreeCommentResponse?: React.Dispatch<React.SetStateAction<string>>;
};

const CheckInFeedBackModal = ({
  toggle,
  isOpen,
  data,
  handleSubmitFeedback,
  loginData,
  fetching,
  feedback,
  setFeedback,
  optionList,
  setQuestionOneResponse,
  questionOneResponse,
  setQuestionTwoResponse,
  questionTwoResponse,
  setQuestionThreeResponse,
  questionThreeResponse,
  type,
  questionOneCommentResponse,
  questionTwoCommentResponse,
  questionThreeCommentResponse,
  setQuestionOneCommentResponse,
  setQuestionTwoCommentResponse,
  setQuestionThreeCommentResponse,
}: AppProps) => {

  const handleQuestionOneResponse = (radioValue: string) => {
    if (setQuestionOneResponse) {
      setQuestionOneResponse(radioValue);
    }
  };

  const handleQuestionTwoResponse = (radioValue: string) => {
    if (setQuestionTwoResponse) {
      setQuestionTwoResponse(radioValue);
    }
  };

  const handleQuestionThreeResponse = (radioValue: string) => {
    if (setQuestionThreeResponse) {
      setQuestionThreeResponse(radioValue);
    }
  };

  const handleQuestionOneCommentResponse = (e: any) => {
    if (setQuestionOneCommentResponse) {
      setQuestionOneCommentResponse(e?.target?.value);
    }
  };

  const handleQuestionTwoCommentResponse = (e: any) => {
    if (setQuestionTwoCommentResponse) {
      setQuestionTwoCommentResponse(e?.target?.value);
    }
  };

  const handleQuestionThirdCommentResponse = (e: any) => {
    if (setQuestionThreeCommentResponse) {
      setQuestionThreeCommentResponse(e?.target?.value);
    }
  };

  return (
    <>
      {fetching ? (
        <Loader />
      ) : (
        <Modal
          centered
          isOpen={isOpen}
          toggle={toggle}
          size="xl"
          style={{ minWidth: "355px" }}
          backdrop="static"
        >
          <ModalHeader toggle={toggle}>{type === "hrmsCheckInReport" ? "Feedback Details" : "Submit Check-In Feedback"}</ModalHeader>
          <ModalBody className="pl-2 pr-2" style={{ paddingLeft: "40px" }}>
            <div className="d-flex" style={{ justifyContent: "center" }}>
              <div style={{ width: "58%" }} className="pr-2">
                <>
                  <div>
                    <h6 className="questions">
                      1. Have you provided project specific, constructive
                      feedback to your team member that will allow them to
                      improve their performance on the project?
                    </h6>
                    {optionList && questionOneResponse && (
                      <div className="mt-3">
                        <RadioContainer
                          optionsList={optionList}
                          handleSetRadioValue={handleQuestionOneResponse}
                          radioValue={questionOneResponse}
                          alignment="horizontal"
                          disable={type === "myCheckInList" || type === "hrmsCheckInReport" || (type === "allCheckInList" && data?.feedback) ? true : false}
                        />
                      </div>
                    )
                    }

                    <form>
                      <div className="form-group mt-3 w-75">
                        <label
                          htmlFor="Comment"
                        // className={comment ? "active" : ""}
                        >
                          Comment
                        </label>
                        <span className="color-red">*</span>
                        <textarea
                          className="form-control"
                          name="pan"
                          value={questionOneCommentResponse}
                          onChange={(e: any) =>
                            handleQuestionOneCommentResponse(e)
                          }
                          placeholder="Add your comment here"
                          disabled={data?.question_1_comment?.length || type === "hrmsCheckInReport" || data?.feedback?.length}
                          style={{
                            border: "1px solid #bfcbe1",
                            borderRadius: "4px",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        />
                      </div>
                    </form>
                  </div>
                  <div
                    style={{
                      marginTop: "40px",
                    }}
                  >
                    <h6 className="questions">
                      2. Is the team member eligible for promotion in current
                      year? If yes, is the performance in line with the
                      increased expectations of new role?
                    </h6>

                    {optionList && questionTwoResponse && (
                      <div className="mt-3">
                        <RadioContainer
                          optionsList={optionList}
                          handleSetRadioValue={handleQuestionTwoResponse}
                          radioValue={questionTwoResponse}
                          alignment="horizontal"
                          disable={type === "myCheckInList" || type === "hrmsCheckInReport" || (type === "allCheckInList" && data?.feedback) ? true : false}
                        />
                      </div>
                    )
                    }

                    <form>
                      <div className="form-group mt-3 w-75">
                        <label
                          htmlFor="Comment"
                        // className={comment ? "active" : ""}
                        >
                          Comment
                        </label>
                        <span className="color-red">*</span>
                        <textarea
                          className="form-control"
                          name="pan"
                          value={questionTwoCommentResponse}
                          onChange={(e: any) =>
                            handleQuestionTwoCommentResponse(e)
                          }
                          placeholder="Add your comment here"
                          disabled={data?.question_2_comment?.length || type === "hrmsCheckInReport" || data?.feedback?.length}
                          style={{
                            border: "1px solid #bfcbe1",
                            borderRadius: "4px",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        />
                      </div>
                    </form>
                  </div>
                  <div
                    style={{
                      marginTop: "40px",
                    }}
                  >
                    <h6 className="questions">
                      3. Do you think the team member is currently operating as
                      a role model in their peer group? (i.e., meeting all
                      compliances, aware of policies, managing client projects
                      exceptionally, participating in firm initiatives)
                    </h6>

                    {optionList && questionThreeResponse && (
                      <div className="mt-3">
                        <RadioContainer
                          optionsList={optionList && optionList}
                          handleSetRadioValue={handleQuestionThreeResponse}
                          radioValue={questionThreeResponse}
                          alignment="horizontal"
                          disable={type === "myCheckInList" || type === "hrmsCheckInReport" || (type === "allCheckInList" && data?.feedback) ? true : false}
                        />
                      </div>
                    )
                    }
                    <form>
                      <div className="form-group mt-3 w-75">
                        <label
                          htmlFor="Comment"
                        // className={comment ? "active" : ""}
                        >
                          Comment
                        </label>
                        <span className="color-red">*</span>
                        <textarea
                          className="form-control"
                          name="pan"
                          value={questionThreeCommentResponse}
                          onChange={(e: any) =>
                            handleQuestionThirdCommentResponse(e)
                          }
                          placeholder="Add your comment here"
                          disabled={data?.question_3_comment?.length || type === "hrmsCheckInReport" || data?.feedback?.length}
                          style={{
                            border: "1px solid #bfcbe1",
                            borderRadius: "4px",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        />
                      </div>
                    </form>
                  </div>
                  <div
                    style={{
                      marginTop: "40px",
                    }}
                  >
                    <h6 className="questions">
                      4. Please share any other comments based on your
                      interaction with the professional that will help in their
                      professional experience. (i.e., behavioural observations,
                      flexibility needs, life updates, etc.)
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={(e: any) => {
                        setFeedback((prv: string) => e?.target?.value);
                      }}
                      style={{
                        height: "200px",
                        width: "75%",
                        resize: "none",
                        border: "1px solid #bfcbe1",
                        borderRadius: "4px",
                        marginTop: "16px",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                      value={feedback}
                      disabled={data?.feedback?.length || type === "hrmsCheckInReport"}
                      placeholder="Add your comment here"
                    ></textarea>
                  </div>
                  {type === "allCheckInList" && (
                    <button
                      className="btn btn-primary mt-4"
                      onClick={(e) => {
                        handleSubmitFeedback && handleSubmitFeedback();
                        toggle();
                      }}
                      disabled={!feedback?.trim()?.length ||
                        !questionOneCommentResponse?.trim()?.length ||
                        !questionTwoCommentResponse?.trim()?.length ||
                        !questionThreeCommentResponse?.trim()?.length ||
                        data?.feedback?.length
                      }
                    >
                      Submit Check-In Feedback
                    </button>
                  )}
                </>
              </div>

              <div
                style={{
                  width: "38%",
                  height: "fit-content",
                  border: "solid 1px #bfcbe1",
                  borderRadius: "5px",
                }}
                className="mt-2"
              >
                <div
                  className="p-3"
                  style={{ fontSize: "13px", fontWeight: 600 }}
                >
                  Employee Profile
                </div>
                <hr className="m-0"></hr>
                <div className="p-3">
                  <div
                    className="d-flex align-items-center "
                    style={{ gap: "3%" }}
                  >
                    <CustomizedAvatar
                      name={`${data?.updated_by?.first_name} ${data?.updated_by?.last_name
                        ? data?.updated_by?.last_name
                        : ""
                        }`}
                      image={
                        data?.updated_by?.profile_pic &&
                        data?.updated_by.profile_pic?.file_url
                      }
                      style={{
                        width: "75px",
                        fontSize: "25px",
                        minWidth: "75px",
                      }}
                    />
                    <div className="ml-2">
                      <p
                        style={{
                          margin: "0px",
                          color: "#262a44",
                          fontWeight: "500",
                          fontSize: "15px",
                        }}
                      >{`${data?.updated_by?.first_name} ${data?.updated_by?.last_name
                        ? data?.updated_by?.last_name
                        : ""
                        }`}</p>
                      <p
                        style={{
                          margin: "0px",
                          fontSize: "13px",
                          color: "#6e7491",
                        }}
                      >
                        {data?.updated_by?.job_title}
                      </p>
                      <p
                        style={{
                          margin: "0px",
                          fontSize: "13px",
                          color: "#6e7491",
                        }}
                      >
                        {data?.updated_by?.department}
                      </p>
                    </div>
                    {/* <div>
                      <div>
                        <p
                          className="mb-1"
                          style={{ fontSize: "15px", fontWeight: 600 }}
                        >
                          {data?.applicant_details?.name}
                        </p>
                        <p className="mt-0 mb-1" style={{ color: "#6e7491" }}>
                          {data?.applicant_details?.email}
                        </p>
                        <div className="mt-0 mb-1" style={{ color: "#6e7491" }}>
                          {data?.applicant_details?.phone_number}
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>

                <div className="inside-card-header d-flex w-100 p-3">
                  <div
                    className="feedBack-heading d-flex align-items-center"
                    style={{ width: "50%" }}
                  >
                    <img src={IdBadge} alt="" className="mr-3" />
                    <div>Employee ID</div>
                  </div>

                  <div style={{ width: "50%" }}>
                    {data?.updated_by?.employee_id ? (
                      <span className="sent">
                        {data?.updated_by?.employee_id}
                      </span>
                    ) : (
                      "NA"
                    )}
                  </div>
                </div>

                <div className="inside-card-header d-flex w-100 p-3">
                  <div
                    className="feedBack-heading d-flex align-items-center"
                    style={{ width: "50%" }}
                  >
                    <img src={BriefCase} alt="" className="mr-3" />
                    <div>Reporting To</div>
                  </div>
                  <div style={{ width: "50%" }}>
                    <div className="d-flex align-items-center">
                      <div>
                        <CircularAvatar
                          name={`${data?.manager?.first_name} ${data?.manager?.last_name}`}
                          image={
                            data?.manager?.profile_pic &&
                            data?.manager.profile_pic?.file_url
                          }
                        />
                      </div>
                      <span className="ml-2">
                        {`${data?.manager?.first_name} ${data?.manager?.last_name}`}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="inside-card-header d-flex w-100 p-3">
                  <div
                    className="feedBack-heading d-flex align-items-center"
                    style={{ width: "50%" }}
                  >
                    <img src={NoticeCalendarIcon} alt="" className="mr-3" />
                    <div>Joining Date</div>
                  </div>
                  <div style={{ width: "50%" }}>
                    {data?.updated_by?.start_date
                      ? reverseDate(data?.updated_by?.start_date?.split("T")[0])
                      : "NA"}
                  </div>
                </div>
                <div className="inside-card-header d-flex w-100 p-3">
                  <span
                    className="feedBack-heading d-flex align-items-center"
                    style={{ width: "50%" }}
                  >
                    <img src={LoctionRedIcon} alt="" className="mr-3" />
                    <div>Job Location</div>
                  </span>
                  <div style={{ width: "50%" }}>
                    {data?.updated_by?.branch_name
                      ? data?.updated_by?.branch_name
                      : "NA"}
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default CheckInFeedBackModal;
